import React, { useEffect, useRef, useState } from 'react';
import hljs from 'highlight.js';
import './style.scss';
import UQIcon from '../icon';

export interface UQCodeProps {
  code: string;
  enableCopy?: boolean;
}

const UQCode: React.FC<UQCodeProps> = ({ code, enableCopy = false }) => {
  const codeRef = useRef<HTMLElement>(null);
  const [copied, setCopied] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(mediaQuery.matches);

    
    const handleChange = (e: MediaQueryListEvent) => {
      setIsDarkMode(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  useEffect(() => {
    
    const themeLinkId = 'hljs-theme';
    let themeLink = document.getElementById(themeLinkId) as HTMLLinkElement;

    if (!themeLink) {
      themeLink = document.createElement('link');
      themeLink.id = themeLinkId;
      themeLink.rel = 'stylesheet';
      document.head.appendChild(themeLink);
    }

    

    const isLocal = window.location.hostname === 'localhost';
    const prefix = (isLocal ? '/src' : '');

    themeLink.href = isDarkMode
      ? prefix + '/styles/themes/code-dark.css'
      : prefix + '/styles/themes/code-light.css';
  }, [isDarkMode]);

  useEffect(() => {
    if (codeRef.current) {
      hljs.highlightElement(codeRef.current);
    }
  }, [code]);

  const handleCopy = () => {
    if (codeRef.current) {
      navigator.clipboard.writeText(codeRef.current.innerText).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  return (
    <div className={`code-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      {enableCopy && (
        <button className="copy-button" onClick={handleCopy}>
          {copied ? <UQIcon icon="check" /> : <UQIcon icon="clipboard" />}
        </button>
      )}
      <pre className="code-mockup">
        <code ref={codeRef} className="html">
          {code}
        </code>
      </pre>
    </div>
  );
};

export default UQCode;